import { put, call, all, select, takeLatest } from "redux-saga/effects";

import { gteBrownLogisticsConfig } from "../services/api";
import { brownLogisticsType } from "../reducers/actionTypes";
import brownLogisticsActions from "@actions/brown.actions";
import { brownConfigDataSelector } from "@selectors/brown.logistics.selector";

function* fetchBrownConfigData() {
  try {
    const { api = {} } = yield select(brownConfigDataSelector);
    const { fetched = false } = api || {};
    const { data } = yield call(gteBrownLogisticsConfig);
    yield put(brownLogisticsActions.getBrownLogisticsType.success(data, null));
    if (!fetched)
      yield put(brownLogisticsActions.getBrownLogisticsType.fetched({}, null));
  } catch (err) {
    yield put(brownLogisticsActions.getBrownLogisticsType.error({ err }, null));
  }
}

export default function* () {
  yield all([
    takeLatest(
      brownLogisticsType.GET_CONFIG_DATA_UPCOMING,
      fetchBrownConfigData,
    ),
  ]);
}
